/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import {
  Table,
  FormControl,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from '../styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  onRemove: PropTypes.func.isRequired,
  onChecked: PropTypes.func.isRequired,
  workNodes: PropTypes.array.isRequired,
  resetComponent: PropTypes.any.isRequired,
  electricNodes: PropTypes.array.isRequired,
};

class Pair extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pairs: [],
      params: [],
    };
    this.remarks = {};
    this.workNodes = props.workNodes;
    this.electricNodes = props.electricNodes;
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.pairs.create');
  }

  componentWillReceiveProps({ workNodes, electricNodes, resetComponent }) {
    if (!_.isEqual(workNodes, this.props.workNodes)) {
      this.workNodes = workNodes;
      this.combinePairs();
    }
    if (!_.isEqual(electricNodes, this.props.electricNodes)) {
      this.electricNodes = electricNodes;
      this.combinePairs();
    }
    if (resetComponent !== this.props.resetComponent) {
      this.setState({ pairs: [] });
      this.remarks = {};
    }
  }

  onChangeRemark(e, id) {
    const remark = _.trimStart(e.target.value);
    this.remarks[id] = remark;
    if (this.timer) {
      clearTimeout(this.tiemr);
    }
    this.timer = _.delay(() => {
      this.props.onChecked(this.state.pairs, this.remarks);
    }, 500);
  }

  combinePairs() {
    const pairs = _.zip(this.workNodes, this.electricNodes);
    this.setState({ pairs });
    this.props.onChecked(pairs, this.remarks);
  }

  removePair(idx) {
    let { pairs } = this.state;
    const removeItem = pairs[idx];
    pairs = _.concat(_.slice(pairs, 0, idx), _.slice(pairs, idx + 1, pairs.length));
    this.setState({ pairs });
    this.props.onRemove(removeItem);
  }

  render() {
    const {
      pairs,
    } = this.state;
    return (
      <div>
        <Table className="aisz-table-light" striped>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('title.work')}</th>
              <th>{this.intlMsg.msg('remark')}</th>
              <th>{this.intlMsg.msg('title.params')}</th>
              <th>{this.intlMsg.msg('remove')}</th>
            </tr>
          </thead>
          <tbody>
            {_.map(pairs, (item, idx) => {
              const workNode = item[0] || {};
              const electricNode = item[1] || {};
              const wMemo = workNode.memo ? JSON.parse(workNode.memo) : {};
              const eMemo = electricNode.memo ? JSON.parse(electricNode.memo) : {};
              let remarkId = '';
              if (workNode.id && this.remarks[workNode.id]) {
                remarkId = workNode.id;
              } else if (electricNode.id && this.remarks[electricNode.id]) {
                remarkId = electricNode.id;
              } else {
                remarkId = workNode.id || electricNode.id;
              }
              return (
                <tr key={idx}>
                  <td>{wMemo.name || workNode.id ||
                    <span className={styles.empty}>{this.intlMsg.msg('empty')}</span>}</td>
                  <td>
                    <FormControl
                      placeholder="备注"
                      className={styles.input}
                      onChange={e => this.onChangeRemark(e, remarkId)}
                    />
                  </td>
                  <td>{eMemo.name || electricNode.id ||
                    <span className={styles.empty}>{this.intlMsg.msg('empty')}</span>}</td>
                  <td>
                    <a
                      className={styles.remove}
                      onClick={() => this.removePair(idx)}
                    >
                      <i className="fa fa-minus-circle" />
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

Pair.propTypes = propTypes;

export default injectIntl(Pair);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Pairs/Pair.jsx